export const countriesArray = [
    { value: 'us', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'ca', label: 'Canada' },
    { value: 'ru', label: 'Russia' },
    { value: 'de', label: 'Germany' },
    { value: 'fr', label: 'France' },
    { value: 'es', label: 'Spain' },
    { value: 'it', label: 'Italy' },
    { value: 'br', label: 'Brazil' },
    { value: 'au', label: 'Australia' },
    { value: 'ar', label: 'Argentina' },
    { value: 'be', label: 'Belgium' },
    { value: 'ch', label: 'Switzerland' },
    { value: 'dk', label: 'Denmark' },
    { value: 'fi', label: 'Finland' },
    { value: 'hk', label: 'Hong Kong' },
    { value: 'ie', label: 'Ireland' },
    { value: 'il', label: 'Israel' },
    { value: 'mx', label: 'Mexico' },
    { value: 'nl', label: 'Netherlands' },
    { value: 'no', label: 'Norway' },
    { value: 'pl', label: 'Poland' },
    { value: 'se', label: 'Sweden' },
    { value: 'sg', label: 'Singapore' },
    { value: 'tr', label: 'Turkey' },
    { value: 'jp', label: 'Japan' },
    { value: 'in', label: 'India' },
    { value: 'hu', label: 'Hungary' },
    { value: 'af', label: 'Afghanistan' },
    { value: 'al', label: 'Albania' },
    { value: 'dz', label: 'Algeria' },
    { value: 'ao', label: 'Angola' },
    { value: 'am', label: 'Armenia' },
    { value: 'at', label: 'Austria' },
    { value: 'az', label: 'Azerbaijan' },
    { value: 'bh', label: 'Bahrain' },
    { value: 'bd', label: 'Bangladesh' },
    { value: 'by', label: 'Belarus' },
    { value: 'bz', label: 'Belize' },
    { value: 'bo', label: 'Bolivia' },
    { value: 'ba', label: 'Bosnia and Herzegovina' },
    { value: 'bw', label: 'Botswana' },
    { value: 'bn', label: 'Brunei' },
    { value: 'bg', label: 'Bulgaria' },
    { value: 'cv', label: 'Cabo Verde' },
    { value: 'kh', label: 'Cambodia' },
    { value: 'cm', label: 'Cameroon' },
    { value: 'cl', label: 'Chile' },
    { value: 'co', label: 'Colombia' },
    { value: 'cr', label: 'Costa Rica' },
    { value: 'hr', label: 'Croatia' },
    { value: 'cy', label: 'Cyprus' },
    { value: 'cz', label: 'Czech Republic' },
    { value: 'cd', label: 'Congo' },
    { value: 'do', label: 'Dominican Republic' },
    { value: 'ec', label: 'Ecuador' },
    { value: 'eg', label: 'Egypt' },
    { value: 'sv', label: 'El Salvador' },
    { value: 'ee', label: 'Estonia' },
    { value: 'et', label: 'Ethiopia' },
    { value: 'ge', label: 'Georgia' },
    { value: 'gh', label: 'Ghana' },
    { value: 'gr', label: 'Greece' },
    { value: 'gt', label: 'Guatemala' },
    { value: 'gy', label: 'Guyana' },
    { value: 'ht', label: 'Haiti' },
    { value: 'hn', label: 'Honduras' },
    { value: 'is', label: 'Iceland' },
    { value: 'id', label: 'Indonesia' },
    { value: 'jm', label: 'Jamaica' },
    { value: 'jo', label: 'Jordan' },
    { value: 'kz', label: 'Kazakhstan' },
    { value: 'kw', label: 'Kuwait' },
    { value: 'lv', label: 'Latvia' },
    { value: 'lb', label: 'Lebanon' },
    { value: 'lt', label: 'Lithuania' },
    { value: 'lu', label: 'Luxembourg' },
    { value: 'mg', label: 'Madagascar' },
    { value: 'my', label: 'Malaysia' },
    { value: 'mt', label: 'Malta' },
    { value: 'mu', label: 'Mauritius' },
    { value: 'md', label: 'Moldova' },
    { value: 'mn', label: 'Mongolia' },
    { value: 'me', label: 'Montenegro' },
    { value: 'ma', label: 'Morocco' },
    { value: 'mz', label: 'Mozambique' },
    { value: 'na', label: 'Namibia' },
    { value: 'np', label: 'Nepal' },
    { value: 'nz', label: 'New Zealand' },
    { value: 'ni', label: 'Nicaragua' },
    { value: 'ng', label: 'Nigeria' },
    { value: 'om', label: 'Oman' },
    { value: 'py', label: 'Paraguay' },
    { value: 'pe', label: 'Peru' },
    { value: 'ph', label: 'Philippines' },
    { value: 'pt', label: 'Portugal' },
    { value: 'ro', label: 'Romania' },
    { value: 'sa', label: 'Saudi Arabia' },
    { value: 'sn', label: 'Senegal' },
    { value: 'rs', label: 'Serbia' },
    { value: 'sk', label: 'Slovakia' },
    { value: 'si', label: 'Slovenia' },
    { value: 'za', label: 'South Africa' },
    { value: 'kr', label: 'South Korea' },
    { value: 'lk', label: 'Sri Lanka' },
    { value: 'th', label: 'Thailand' },
    { value: 'bs', label: 'Bahamas' },
    { value: 'tt', label: 'Trinidad and Tobago' },
    { value: 'tn', label: 'Tunisia' },
    { value: 'ua', label: 'Ukraine' },
    { value: 'ae', label: 'United Arab Emirates' },
    { value: 'uy', label: 'Uruguay' },
    { value: 've', label: 'Venezuela' },
    { value: 'vn', label: 'Vietnam' },
    { value: 'zm', label: 'Zambia' },
    { value: 'zw', label: 'Zimbabwe' },
    { value: 'ly', label: 'Libya' },
    { value: 'pa', label: 'Panama' },
    { value: 'pk', label: 'Pakistan' },
    { value: 'tw', label: 'Taiwan' },
    { value: 'qa', label: 'Qatar' },
];
